import axios from 'axios';
import * as actionTypes from './types';
import { socket } from '../socket';
import { store } from '../store';

export const retrieveMilestones = (journeyId) => {
  return (dispatch) => {
    axios
      .get('/api/milestone/journey_id/' + journeyId)
      .then((res) => {
        if (res.data.milestones.length > 0) {
          for (const milestone of res.data.milestones) {
            dispatch(
              addMilestone(milestone.position, milestone.id, milestone.content)
            );
            dispatch(
              updateMilestoneProduct(
                milestone.position,
                milestone.product_ids || []
              )
            );
            dispatch(
              updateMilestonePersona(
                milestone.position,
                milestone.persona_ids || []
              )
            );
            dispatch(
              updateMilestoneConnectorOrder(
                milestone.position,
                milestone.connector_ids || []
              )
            );
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const deleteJourneyMilestones = (journeyId) => {
  return (dispatch) => {
    axios
      .delete('/api/milestone/journey_id/' + journeyId)
      .then((result) => {})
      .catch((error) => {
        console.log(error);
      });
  };
};

export const updateMilestoneProductDB = (stageName, id, products) => async (
  dispatch
) => {
  const { [stageName]: currentMilestone } = store.getState().milestones;
  await axios
    .patch(`/api/milestone/${id}`, {
      milestone: { ...currentMilestone, productIds: [...products] },
    })
    .then((res) => {
      dispatch(updateMilestoneProduct(stageName, products));
    })
    .catch((error) => {
      console.log(error);
    });
};

export const updateMilestoneProduct = (stageName, products) => ({
  type: actionTypes.UPDATE_MILESTONE_PRODUCT,
  stageName,
  products,
});

export const updateMilestonePersonaDB = (stageName, id, personas) => async (
  dispatch
) => {
  const { [stageName]: currentMilestone } = store.getState().milestones;

  await axios
    .patch(`/api/milestone/${id}`, {
      milestone: { ...currentMilestone, personaIds: [...personas] },
    })
    .then((res) => {
      dispatch(updateMilestonePersona(stageName, personas));
    })
    .catch((error) => {
      console.log(error);
    });
};

export const updateMilestonePersona = (stageName, personas) => ({
  type: actionTypes.UPDATE_MILESTONE_PERSONA,
  stageName,
  personas,
});



/**
 * TODO: ADD MILESTONE [SOCKET FUNCTION]
 * @param {*} journeyId: the assoociate journey 
 * @param {*} position: which milestone the content is associate with
 * @param {*} id: the idea id
 * @param {*} content: the content of the milestone
 */
export const addMilestoneDBOnly = (journeyId, position, id, content) => {
  return () => {
    socket.emit('onMilestoneAddServer', { 
      journey_id: journeyId,
      position: position,
      id: id,
      content : content,
    });
  };
};




/**
 * TODO: ADD MILESTONE [REDUX ACTION]
 * @param {*} id: milestone database id
 * @param {*} stageName: determines which milestone it's associate with
 * @param {*} content: the content of the milestone
 */
export const addMilestone = (position, id, content) => ({
  type: actionTypes.ADD_MILESTONE,
  stageName: position,
  id: id,
  content: content,
});




/**
 * TODO: UPDATE MILESTONE CONNECTOR [SOCKET EVENT]
 * @param {*} journeyId: journey the connector is associated to
 * @param {*} milestone: milestone the connector is associated to 
 * @param {*} connectorId: id of the milestone connector 
 * @param {*} method: method names are limited to ADD, UP, DOWN, DELETE 
 */
export const updateMilestoneConnectorOrderDBOnly = (journeyId, milestone, connectorIds) => {
  return () => {
    socket.emit('onMilestoneConnectorOrderUpdateServer', { 
      journeyId: journeyId,
      milestone: milestone,
      connectorIds: connectorIds,
    });
  };
}




/**
 * TODO: UPDATE MILESTONE CONNECTOR ORDER [REDUX ACTION]
 * @param {*} stageName 
 * @param {*} connectorIds 
 */
export const updateMilestoneConnectorOrder = (stageName, connectorIds) => ({
  type: actionTypes.UPDATE_MILESTONE_CONNECTOR_ORDER,
  stageName,
  connectorIds,
});